import React from "react";
import { InvoiceReportHeader } from "./InvoiceReportHeader";
import { InvoiceReportTotalSection } from "./InvoiceReportTotalSection";
import { getInvoiceTotalPresentation } from "../../../helpers/invoiceReport";
import { ReportRule } from "../../report/ReportRule";
import { ReportSectionPresentation } from "../../report/ReportSectionPresentation";
import { ReportNotesSection } from "../../report/ReportNotesSection";
import { ReportPaymentInstructionsSection } from "../../report/ReportPaymentInstructionsSection";
import { ReportInvoiceFooterSection } from "../../report/ReportInvoiceFooterSection";
import "../../report/ReportPreviewDocument.css";
import "./InvoiceReportLayout.css";

function resolveOrderedSections(reportModel) {
  if (Array.isArray(reportModel?.sectionsOrdered)) {
    return reportModel.sectionsOrdered;
  }

  const sections = reportModel?.sections || {};
  return ["services", "labour", "materials"]
    .filter((id) => sections[id])
    .map((id) => ({
      id,
      title:
        id === "services"
          ? "Services"
          : id === "labour"
            ? "Labour"
            : "Materials",
      section: sections[id],
    }));
}

export function InvoiceReportDocument({ reportModel }) {
  if (!reportModel) return null;

  const {
    header,
    notes,
    paymentInstructions,
    paymentTerms,
    customerNotes,
    invoiceFooter,
  } = reportModel;
  const totalPresentation = getInvoiceTotalPresentation(reportModel);
  const orderedSections = resolveOrderedSections(reportModel);
  const customerNotesText =
    customerNotes?.notes || notes || null;

  return (
    <article
      className="report-preview-document invoice-report-document"
      aria-label="Invoice"
    >
      <InvoiceReportHeader fields={header.fields} variant="preview" />

      {orderedSections.map(({ id, title, section }) => (
        <ReportSectionPresentation
          key={id}
          title={title}
          section={section}
          variant="preview"
        />
      ))}

      {totalPresentation && (
        <>
          <ReportRule variant="preview" />
          <div className="er-totals-wrap">
            <InvoiceReportTotalSection
              reportModel={reportModel}
              variant="preview"
            />
          </div>
        </>
      )}

      {paymentInstructions && (
        <ReportPaymentInstructionsSection
          paymentInstructions={paymentInstructions}
          variant="preview"
        />
      )}

      {paymentTerms && (
        <ReportPaymentInstructionsSection
          paymentInstructions={paymentTerms}
          variant="preview"
        />
      )}

      {customerNotesText && (
        <ReportNotesSection
          notes={customerNotesText}
          title={customerNotes?.title || "Customer Notes"}
          variant="preview"
        />
      )}

      <ReportInvoiceFooterSection
        invoiceFooter={invoiceFooter}
        variant="preview"
      />
    </article>
  );
}
